import { useContext } from 'react'
import MyAppContext from '../contexts/MyAppContext'

const useMyApp = () => useContext(MyAppContext)

export default useMyApp
